import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const Diff = () => {

    const { sha } = useParams();

    const [reviewInfo, setReviewInfo] = useState({
        owner: null,
        name: null,
        keywords: [],
        message: null,
        evals: [],
        resolution: null,
    });

    const [diff, setDiff] = useState('');

    function eval_review() {
        let mentionsSecurity = document.getElementById('MentionSecurity').value;
        let reason = document.getElementById('reason').value;
        let isSecurity = document.getElementById('isSecurity').value;
        let comment = document.getElementById('comment').value;

        if (isSecurity === 'Select' || mentionsSecurity === 'Select') {
            alert('Please fill all fields');
            return;
        }

        fetch(process.env.REACT_APP_BACKEND_URL + 'eval_discrepancy', {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({
                token: localStorage.getItem("token"),
                username: localStorage.getItem("user"),
                sha: sha,
                mentionsSecurity: mentionsSecurity === 'true',
                reason: reason,
                isSecurity: isSecurity === 'true',
                comment: comment
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.res === 'ok') {
                    alert('Discrepancy evaluated');
                } else {
                    alert('Error evaluating Discrepancy');
                }
            })
            .catch(error => {
                console.error("Error:", error);
                alert('Error evaluating Discrepancy');
            });

    }

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_discrepancy/' + sha, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user") }),
        })
            .then(response => response.json())
            .then(data => {
                setReviewInfo(data);
                if (data.resolution.security != null) {
                    document.getElementById('MentionSecurity').value = data.resolution.mentions_security ? 'true' : 'false';
                    document.getElementById('reason').value = data.resolution.reason;
                    document.getElementById('isSecurity').value = data.resolution.security ? 'true' : 'false';
                    document.getElementById('comment').value = data.resolution.comment;
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, [sha]);

    useEffect(() => {
            fetch(process.env.REACT_APP_BACKEND_URL + 'get_commit_diff/' + sha, {
                method: "POST",
                headers: {
                    "Content-Type": "text/plain",
                },
                body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user") }),
            })
                .then(response => response.json())
                .then(data => {
                    setDiff(data.diff); 
                })
                .catch(error => {
                    console.error("Error fetching diff:", error);
                });
        }, [sha]);


    return (
        <>
            <div className="m-10">
                <div className="border-b border-gray-900/10 pb-12 justify-center">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Review</h1>
                </div>
            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12 grid md:grid-cols-3 gap-4 sm:grid-cols-1">
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Repository:</h1>
                    <p>{reviewInfo.owner}/{reviewInfo.name}</p>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">URL:</h1>
                    <Link target="_blank" to={'https://github.com/' + reviewInfo.owner + '/' + reviewInfo.name + '/commit/' + sha}>
                        <p className="text-blue-500 hover:underline">
                            https://github.com/{reviewInfo.owner}/{reviewInfo.name}/commit/{sha}
                        </p>
                    </Link>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">URL eval:</h1>
                    <a
                    href={window.location.origin + '/commit/' + sha}
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    <p className="text-blue-500 hover:underline">
                        {window.location.origin}/commit/{sha}
                    </p>
                    </a>

                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Keywords:</h1>
                    <p>{reviewInfo.keywords.join(', ')}</p>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Message:</h1>
                    <p>{reviewInfo.message}</p>
                </div>
                <div className="col-span-1 break-words">
                    <div className="col-span-1 shadow-md p-3 overflow-y-auto h-96 bg-gray-50 relative">
                        {/* Copy Button */}
                        <button
                            onClick={() => {
                                const textToCopy = `Message:\n${reviewInfo.message}\n\nFile Diff:\n${diff}`;
                                navigator.clipboard.writeText(textToCopy)
                                    .catch(err => console.error('Failed to copy: ', err));
                            }}
                            className="absolute top-2 right-2 rounded-md bg-gray-800 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-800"
                        >
                            Copy
                        </button>

                        {/* Message and Diff */}
                        <h1 className="text-base font-semibold leading-7 text-gray-900">File Diff:</h1>
                        <pre className="text-sm whitespace-pre-wrap text-left">{diff}</pre>
                    </div>
                </div>

            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12">
                <div className="">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Resolution:</h1>
                </div>
                <div className="grid md:grid-cols-4 gap-4 sm:grid-cols-1">
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Mention Security:</label>
                        <select id="MentionSecurity" className="w-full">
                            <option value="Select">Select</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Reason:</label>
                        <textarea type="text" id="reason" className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Is Security:</label>
                        <select className="w-full" id="isSecurity">
                            <option value="Select">Select</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Comment:</label>
                        <textarea type="text" id="comment" className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                </div>
                
                {/* Conditional Button to evaluate the review */}
                {localStorage.getItem("user") === 'lcentellas' ? 
                <div className="mt-4 flex grid justify-items-end gap">
                <button onClick={eval_review}
                    className="rounded-md bg-gray-800 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-800"
                >
                    Evaluate
                </button>
                </div>
                :
                null}
                
            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12">
                <div className="">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Evaluations:</h1>
                </div>
                <div className="grid md:grid-cols-2 gap-2 sm:grid-cols-1">
                {reviewInfo.evals.map((element, index) => (
                    <div key={index} className="col-span-1 shadow-md p-3 overflow-y-auto h-96">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Eval {element.reviewer}</h1>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Mentions Security:</h1>
                    <p>{element.mentions_security ? 'True' : 'False'}</p>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Reason:</h1>
                    <p>{element.reason}</p>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Is Security:</h1>
                    <p>{element.security ? 'True' : 'False'}</p>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Comment:</h1>
                    <p>{element.comment}</p>
                    </div>
                ))}
                </div>

            </div>
        </>
    );
}

export default Diff;